import { hySelectEngine } from "..";
import { trackLiveObjects } from "../helpers/trackLiveObjects";
import { unitsVectorToOptions } from "./unitsVectorToOptions";

export type UnitsOptions = ReturnType<typeof unitsRepository.getOptions>;

export const unitsRepository = trackLiveObjects("unitsRepository", {
  getOptions() {
    const units = hySelectEngine.initUnits();

    if (!units) {
      throw new Error(
        "Could not get the units instance from the HySelect engine.",
      );
    }

    const options = {
      area: unitsVectorToOptions(units.getAreaUnits()),
      density: unitsVectorToOptions(units.getDensityUnits()),
      diameter: unitsVectorToOptions(units.getDiameterUnits()),
      differentialPressure: unitsVectorToOptions(
        units.getDifferentialPressureUnits(),
      ),
      electricalPower: unitsVectorToOptions(units.getElectricalPowerUnits()),
      energy: unitsVectorToOptions(units.getEnergyUnits()),
      flow: unitsVectorToOptions(units.getFlowUnits()),
      force: unitsVectorToOptions(units.getForceUnits()),
      heatTransfer: unitsVectorToOptions(units.getHeatTransferUnits()),
      kinematicViscosity: unitsVectorToOptions(
        units.getKinematicViscosityUnits(),
      ),
      kvCvCoefficient: unitsVectorToOptions(units.getKvCvCoefficientUnits()),
      length: unitsVectorToOptions(units.getLengthUnits()),
      linearPressureDrop: unitsVectorToOptions(
        units.getLinearPressureDropUnits(),
      ),
      mass: unitsVectorToOptions(units.getMassUnits()),
      roughness: unitsVectorToOptions(units.getRoughnessUnits()),
      specificHeat: unitsVectorToOptions(units.getSpecificHeatUnits()),
      staticPressure: unitsVectorToOptions(units.getStaticPressureUnits()),
      temperature: unitsVectorToOptions(units.getTemperatureUnits()),
      temperatureDifference: unitsVectorToOptions(
        units.getTemperatureDifferenceUnits(),
      ),
      thermalConductivity: unitsVectorToOptions(
        units.getThermalConductivityUnits(),
      ),
      thermalPower: unitsVectorToOptions(units.getThermalPowerUnits()),
      thickness: unitsVectorToOptions(units.getThicknessUnits()),
      torque: unitsVectorToOptions(units.getTorqueUnits()),
      velocity: unitsVectorToOptions(units.getVelocityUnits()),
      volume: unitsVectorToOptions(units.getVolumeUnits()),
      waterHardness: unitsVectorToOptions(units.getWaterHardnessUnits()),
    };
    hySelectEngine.exitUnits();
    return options;
  },
});
